import { Center, Spinner } from '@chakra-ui/react';
import { SerializedError } from '@reduxjs/toolkit';
import { FetchBaseQueryError } from '@reduxjs/toolkit/dist/query';
import { FC } from 'react';

import ErrorContainer from 'presentation/components/shared/ErrorContainer';
import AppCard from 'presentation/components/shared/card/AppCard';
import PeCompanyDataLoaded from './PeCompanyDataLoaded';
import ActivesPageLayout from 'presentation/layout/modules/actives/ActivesPageLayout';
import PeCompanyStockActionCard from './info/sections/PeCompanyStockActionCard';

interface Props {
  assetId: ID;
  data?: PeCompanyDetail;
  error?: FetchBaseQueryError | SerializedError;
  refetch: () => void;
  isFetching: boolean;
}

const PeCompanyDataView: FC<Props> = ({
  data,
  error,
  refetch,
  isFetching,
  assetId,
}) => {
  if (data) {
    return (
      <ActivesPageLayout
        sidebarContent={<PeCompanyStockActionCard {...data} />}
      >
        <PeCompanyDataLoaded company={data} assetId={assetId} />
      </ActivesPageLayout>
    );
  }

  let content;
  if (isFetching) {
    content = <Spinner />;
  } else if (error) {
    content = (
      <ErrorContainer
        error={error}
        onRetry={() => {
          refetch();
        }}
      />
    );
  } else {
    content = <Spinner />;
  }

  return (
    <ActivesPageLayout>
      <AppCard p="20px">
        <Center>{content}</Center>
      </AppCard>
    </ActivesPageLayout>
  );
};

export default PeCompanyDataView;
